import { axiosInstanceAuth } from "../mosaic/setup";
import {
  AdminRole,
  CreateAdminPayload,
  SurgoAdmin,
  SurgoApiResponse,
} from "./interface";

export const getAdmins = async (): Promise<SurgoAdmin[]> => {
  const response = await axiosInstanceAuth().get<SurgoApiResponse<SurgoAdmin[]>>(
    "/admin/fetch_admins"
  );
  return response.data.data;
};

export const getAdminRoles = async (): Promise<AdminRole[]> => {
  const response = await axiosInstanceAuth().get<SurgoApiResponse<AdminRole[]>>(
    "/admin/fetch_admin_roles"
  );
  return response.data.data;
};

/**
 * Resolves to the new admin's temporary password. No email is sent yet, so the
 * caller has to show it.
 */
export const createAdmin = async (payload: CreateAdminPayload): Promise<string> => {
  const response = await axiosInstanceAuth().post<SurgoApiResponse<string>>(
    "/admin/create_admin_account",
    payload
  );
  return response.data.data;
};

export const updateAdminRole = async (adminId: number, roleId: number): Promise<void> => {
  await axiosInstanceAuth().put(`/admin/update_admin_role/${adminId}`, { role_id: roleId });
};

export const deleteAdmin = async (adminId: number): Promise<void> => {
  await axiosInstanceAuth().delete(`/admin/delete_admin/${adminId}`);
};
